import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userName, ipAddress } from "./Univ.js";

function AddElectionIncident() {
  const [booths, setBooths] = useState([]);
  const [rows, setRows] = useState([]);

  const [form, setForm] = useState({
    booth: "",
    incident_type: "",
    description: "",
    severity: "1",
  });

  // ---------- FETCH BOOTHS ----------
  useEffect(() => {
    axios.get(baseUrl + "booths/").then((r) => setBooths(r.data));
  }, []);

  // ---------- FETCH INCIDENTS ----------
  const fetchIncidents = () => {
    axios
      .get(baseUrl + "incidents/")
      .then((r) => setRows(r.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchIncidents();
  }, []);

  // ---------- HANDLE CHANGE ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // ---------- SUBMIT ----------
  const submit = () => {
    if (!form.booth || !form.incident_type) {
      Swal.fire("Error", "Booth and Incident Type are required", "error");
      return;
    }

    const payload = {
      ...form,
      addedby: userName,
      ip_add: ipAddress,
    };

    axios
      .post(baseUrl + "incidents/", payload)
      .then(() => {
        Swal.fire("Saved", "Incident reported", "success");
        setTimeout(() => window.location.reload(), 1000);

        setForm({
          booth: "",
          incident_type: "",
          description: "",
          severity: "1",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to report incident", "error");
      });
  };

  // ---------- DELETE ----------
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This incident will be permanently deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "delete-incidents/" + id + "/").then(() => {
          Swal.fire("Deleted", "Incident removed", "success");
          fetchIncidents();
        });
      }
    });
  };

  // ---------- DATAGRID COLUMNS ----------
  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "booth",
      headerName: "Booth",
      width: 120,
      renderCell: (params) =>
        `Booth ${params.value?.booth_number || params.value}`,
    },

    { field: "incident_type", headerName: "Incident Type", width: 180 },

    { field: "description", headerName: "Description", width: 250 },

    {
      field: "severity",
      headerName: "Severity",
      width: 120,
      renderCell: (params) => {
        if (params.value === 1) return "Low";
        if (params.value === 2) return "Medium";
        if (params.value === 3) return "High";
        return "-";
      },
    },

    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => handleDelete(params.id)}
        >
          Delete
        </button>
      ),
    },
  ];

  return (
    <section className="container mt-4">
      {/* -------- FORM CARD -------- */}
      <div className="card">
        <h4 className="card-header">Election Incident</h4>

        <div className="card-body">
          <select
            className="form-control mb-3"
            name="booth"
            value={form.booth}
            onChange={handleChange}
          >
            <option value="">-- Select Booth --</option>
            {booths.map((b) => (
              <option key={b.id} value={b.id}>
                Booth {b.booth_number}
              </option>
            ))}
          </select>

          <input
            className="form-control mb-3"
            name="incident_type"
            placeholder="Incident Type"
            value={form.incident_type}
            onChange={handleChange}
          />

          <textarea
            className="form-control mb-3"
            name="description"
            placeholder="Description"
            value={form.description}
            onChange={handleChange}
          />

          <select
            className="form-control mb-3"
            name="severity"
            value={form.severity}
            onChange={handleChange}
          >
            <option value="1">Low</option>
            <option value="2">Medium</option>
            <option value="3">High</option>
          </select>

          <button className="btn btn-danger" onClick={submit}>
            Report Incident
          </button>
        </div>
      </div>

      {/* -------- DATAGRID -------- */}
      <div className="mt-4">
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
        />
      </div>
    </section>
  );
}

export default AddElectionIncident;
